import { TExportDashlet } from '../../dashboard-export-modal/dashboard-export-dashlet.model';
import { TDashletEventsRequestData } from '../../dashlet/dashlet-events/dashlet-events.consts';

export function findSimpleDashletData(
  dashlet: TExportDashlet,
  dashletsData: TDashletEventsRequestData[],
): TDashletEventsRequestData {
  return dashletsData.find((_dashlet) => {
    const accountIdMatch =
      (!_dashlet.accountId && !dashlet.selectedRange.accountId) ||
      _dashlet.accountId === dashlet.selectedRange.accountId;

    const noneContainWorkspaceIds =
      !_dashlet.workspaceIds?.length && !dashlet.selectedRange?.workspaceIds?.length;

    const workspaceIdsMatch =
      noneContainWorkspaceIds ||
      (_dashlet.workspaceIds?.every((workspaceId) =>
        dashlet.selectedRange.workspaceIds?.includes(workspaceId),
      ) &&
        dashlet.selectedRange.workspaceIds?.every((workspaceId) =>
          _dashlet.workspaceIds?.includes(workspaceId),
        ));

    const typeMatch = _dashlet.type === dashlet.name;
    const periodMatch = _dashlet.period === dashlet.period;

    return accountIdMatch && workspaceIdsMatch && typeMatch && periodMatch;
  });
}
